import { Button, Form, InputNumber, Select } from 'antd';
import { Modal } from 'components';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';

export const SubscriptionViewModal = ({ onClose }: { onClose: () => void }) => {
  const [form] = Form.useForm();

  const handleFinish = () => {
    // Add your save logic here (e.g., API call)
    onClose();
  };

  return (
    <StyledUserModalWrapper>
      <Modal
        className='right-modal mtch_dtls_modal'
        open
        centered
        title='Add SubScription'
        onCancel={() => {
          document.body.style.overflow = 'auto'; // revert body scroll
          onClose();
        }}
        style={{ width: '670px' }}
        getContainer={false}
        footer={null} // We'll use a custom footer below
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <Form form={form} layout='vertical' onFinish={handleFinish}>
          <Form.Item
            label='Facility'
            name='commission'
            rules={[{ required: true, message: 'Please Select a facility' }]}
          >
            <Select></Select>
          </Form.Item>
          <Form.Item
            label='Court'
            name='commission'
            rules={[{ required: true, message: 'Please Select a Court' }]}
          >
            <Select
              style={{ width: '100%' }}
              options={[
                { value: '1', label: '1' },
                { value: '2', label: '2' },
                { value: '3', label: '3' },
              ]}
            />
          </Form.Item>
          <Form.Item
            label='Minimum Per Month'
            name='Minimum'
            rules={[
              { required: true, message: 'Please enter a Minimum value' },
            ]}
          >
            <InputNumber
              style={{ width: '100%' }}
              placeholder='Enter a decimal value'
              min={0}
              step={0.01}
              stringMode
            />
          </Form.Item>
          <Form.Item
            label='Main revenue'
            name='Cap'
            rules={[{ required: true, message: 'Please enter a Main Revenue' }]}
          >
            <InputNumber
              style={{ width: '100%' }}
              placeholder='Enter a decimal value'
              min={0}
              step={0.01}
              stringMode
            />
          </Form.Item>
          {/* Custom Footer */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '10px',
              marginTop: '24px',
            }}
          >
            <Button onClick={onClose}>Cancel</Button>
            <Button type='primary' onClick={() => form.submit()}>
              Save
            </Button>
          </div>
        </Form>
      </Modal>
    </StyledUserModalWrapper>
  );
};
